import { render, staticRenderFns } from "./InternalMenuLogistic.vue?vue&type=template&id=c0490df4&scoped=true&"
import script from "./InternalMenuLogistic.vue?vue&type=script&lang=js&"
export * from "./InternalMenuLogistic.vue?vue&type=script&lang=js&"
import style0 from "./InternalMenuLogistic.vue?vue&type=style&index=0&id=c0490df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0490df4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VList,VListItem,VListItemTitle,VRow})
